// Iter-276.G (Top-20 #20) — ScoreBar extracted from PartnerRateTable.jsx
// as part of the LoC refactor. 5-point editorial score bar used inside
// the ScoreBreakdown expanded panel.

import React from "react";

export default function ScoreBar({ value }) {
  const pct = Math.max(0, Math.min(5, value || 0)) * 20;
  return (
    <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
      <div
        className="h-full bg-[#10B981] rounded-full transition-[width]"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
